
import Component from "vue-class-component"
import PageHeader from "@/superannuation/PageHeader.vue"
import HelpIcon from "@/ui/HelpIcon.vue"
import Vue from "vue"
import SelectDropDown from "@/components/SelectDropDown.vue"
import {QPopupProxy} from "quasar"
import Axios, {AxiosError, AxiosResponse} from "axios"
import {Member} from "@/superannuation/PlanService"
import ErrorMessage from "@/components/ErrorMessage.vue"
import {getIsoDate} from "@/utils/formatter"
import {format, startOfMonth} from "date-fns"
import _ from "lodash"

export interface OneCentralAccess {
  id: string
  sessionId: string
  sessionStart: string
  duration: string
  username: string
  userAgent: string
  remoteAddress: string
  actions: Array<OneCentralAction>
}

export interface OneCentralAction {
  id: string
  timestamp: string
  action: string
  context: string
  type: string
  path: string
  referrer: string
}

@Component({
  components: {
    ErrorMessage,
    SelectDropDown,
    PageHeader,
    HelpIcon,
    QPopupProxy,
  },
})
export default class OneCentralAccessView extends Vue {
  readonly visibleAccessColumns = [
    "sessionId",
    "sessionStart",
    "duration",
    "username",
    "remoteAddress",
  ]

  readonly visibleActionColumns = [
    "timestamp",
    "action",
    "context",
    "type",
    "path",
    "referrer",
  ]

  $refs: {
    ocUserSelect: SelectDropDown
    ecUserSelect: SelectDropDown
    actionSelect: SelectDropDown
    memberSelect: SelectDropDown
    qStartDateProxy: QPopupProxy
    qEndDateProxy: QPopupProxy
  }

  sessions: Array<OneCentralAccess> = new Array<OneCentralAccess>()

  ocUser: User | null = null
  ecUser: User | null = null
  action: string | null = null
  member: Member | null = null
  startDate: string | null = format(startOfMonth(Date.now()), "dd/MM/yyyy")
  endDate: string | null = null

  message: string | null = null

  dataInProgress = false

  dateRule = (v: string) =>
    _.isEmpty(v) ||
    /^([0-2]\d|(3)[01])(\/)(((0)\d)|((1)[0-2]))(\/)\d{4}$/.test(v)

  async created() {
    await this.getAccessActivity()
  }

  private async refresh(done: () => void) {
    await this.getAccessActivity()
    done()
  }

  private ocUserSelected(user: User | null) {
    this.ocUser = user
    this.$refs.ecUserSelect.model = null
    this.ecUser = null
  }

  private ecUserSelected(user: User | null) {
    this.ecUser = user
    this.$refs.ocUserSelect.model = null
    this.ocUser = null
  }

  private actionSelected(action: string | null) {
    this.action = action
  }

  private memberSelected(member: Member | null) {
    this.member = member
  }

  private memberLabel(): (option: Member) => string {
    return (option: Member) =>
      `${option.surname} [${option.login}] - ${option.companyName}`
  }

  private async getAccessActivity() {
    this.dataInProgress = true
    await Axios.get(`/api/onecentral/access`, {
      params: {
        startDate: getIsoDate(this.startDate),
        endDate: getIsoDate(this.endDate),
        resourceId: this.ocUser?.id,
        userId: this.ecUser?.id,
        recordId: this.member?.id,
        actionType: this.action,
      },
    })
      .then((response: AxiosResponse) => {
        this.message = null
        this.sessions = response.data
      })
      .catch((reason: AxiosError<any>) => {
        this.message = reason.response?.data.message
      })
      .finally(() => (this.dataInProgress = false))
  }
}
